import { useDispatch, useSelector } from "react-redux";
import { downloadMonthlyClientExcel } from "../thunks/downloadMonthlyClientReportExcel";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useMonthlyClientExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.monthlyTrade.downloadReportFetchState
  );

  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadMonthlyClientExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
